// extracted by mini-css-extract-plugin
export default {"Main":"BaseTip_Main__j4n-J","Name":"BaseTip_Name__b8zUH","IMG":"BaseTip_IMG__oSPKE","Target":"BaseTip_Target__Yz5Gm"};